import _defineProperty from "/app/web/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "/app/web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "/app/web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _regeneratorRuntime from "/app/web/node_modules/@babel/runtime/regenerator";
import { closestCenter, DndContext, KeyboardSensor, PointerSensor, useSensor, useSensors } from '@dnd-kit/core';
import { arrayMove, SortableContext, sortableKeyboardCoordinates, useSortable, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { message, Modal } from 'antd';
import { getTaskSearchesStore } from 'core/modules/tasks/task-search.store';
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
export var TasksListSearchesOrderModal = function TasksListSearchesOrderModal(_ref) {
  var visible = _ref.visible,
      onClose = _ref.onClose;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _getTaskSearchesStore = getTaskSearchesStore(),
      isLoading = _getTaskSearchesStore.isLoading,
      searches = _getTaskSearchesStore.searches,
      updateTaskSearchesOrder = _getTaskSearchesStore.updateTaskSearchesOrder;

  var sensors = useSensors(useSensor(PointerSensor), useSensor(KeyboardSensor, {
    coordinateGetter: sortableKeyboardCoordinates
  }));

  var _useState = useState([]),
      items = _useState[0],
      setItems = _useState[1];

  var _useState2 = useState(false),
      hasSorted = _useState2[0],
      setHasSorted = _useState2[1];

  var positions = useMemo(function () {
    return items.map(function (item, index) {
      return {
        id: item.id,
        position: index
      };
    });
  }, [items]);

  function onSubmit() {
    return _onSubmit.apply(this, arguments);
  }

  function _onSubmit() {
    _onSubmit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return updateTaskSearchesOrder(positions);

            case 3:
              message.success(t('changesSaved'));
              onClose();
              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              message.error(t('unknownError'));

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    }));
    return _onSubmit.apply(this, arguments);
  }

  function handleDragEnd(event) {
    var active = event.active,
        over = event.over;

    if (active.id !== over.id) {
      setItems(function (items) {
        var oldIndex = items.findIndex(function (item) {
          return item.id === active.id;
        });
        var newIndex = items.findIndex(function (item) {
          return item.id === over.id;
        });
        return arrayMove(items, oldIndex, newIndex);
      });
      setHasSorted(true);
    }
  }

  useEffect(function () {
    setItems(_toConsumableArray(searches));
    setHasSorted(false);
  }, [searches]);
  return /*#__PURE__*/_jsx(Container, {
    open: visible,
    onCancel: onClose,
    onOk: onSubmit,
    okText: t('save'),
    okButtonProps: {
      loading: isLoading,
      disabled: !hasSorted
    },
    width: 400,
    title: t('tasksList.changeOrder'),
    children: /*#__PURE__*/_jsx("div", {
      className: "searches",
      children: /*#__PURE__*/_jsx(DndContext, {
        sensors: sensors,
        collisionDetection: closestCenter,
        onDragEnd: handleDragEnd,
        children: /*#__PURE__*/_jsx(SortableContext, {
          items: items,
          strategy: verticalListSortingStrategy,
          children: items.map(function (search) {
            return /*#__PURE__*/_jsx(SortableItem, {
              item: search
            }, search.id);
          })
        })
      })
    })
  });
};
export var SortableItem = function SortableItem(_ref2) {
  var item = _ref2.item;

  var _useSortable = useSortable({
    id: item.id
  }),
      attributes = _useSortable.attributes,
      listeners = _useSortable.listeners,
      setNodeRef = _useSortable.setNodeRef,
      transform = _useSortable.transform,
      transition = _useSortable.transition;

  var style = {
    transform: CSS.Transform.toString(transform),
    transition: transition
  };
  return /*#__PURE__*/_jsx(ItemContainer, _objectSpread(_objectSpread(_objectSpread({
    ref: setNodeRef,
    style: style
  }, attributes), listeners), {}, {
    children: item.title
  }));
}; // Styles

var Container = styled(Modal).withConfig({
  displayName: "SearchesOrderModal__Container",
  componentId: "sc-xec2c-0"
})([".searches{overflow:'auto';}"]);
var ItemContainer = styled.div.withConfig({
  displayName: "SearchesOrderModal__ItemContainer",
  componentId: "sc-xec2c-1"
})(["padding:12px;margin:12px;box-shadow:0 1px 4px #3336;border-radius:4px;background:white;cursor:move;"]);